module.exports = __webpack_public_path__ + "img/syukyaku-tei-001sp.e350d97e.jpg";